import { render, staticRenderFns } from "./faq-image.vue?vue&type=template&id=84658514&scoped=true&"
import script from "./faq-image.vue?vue&type=script&lang=js&"
export * from "./faq-image.vue?vue&type=script&lang=js&"
import style0 from "./faq-image.vue?vue&type=style&index=0&id=84658514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84658514",
  null
  
)

export default component.exports